import * as themes from "./themes";
import base from "./base";

type StyleType = { [key: string]: typeof base };

const styles: StyleType = Object.keys(themes).reduce((obj, themeName) => {
	obj[themeName] = base(themes[themeName]);
	return obj;
}, {});

const createStyles = (key: string, theme: string | object) => {
	// console.debug(styles, theme, styles[theme])
	if (typeof theme === "string") {
		return styles[theme][key];
	}
	if (typeof theme === "object") {
		return base(theme)[key];
	}
	// Default styles
	return styles.chromeLight[key];
};

export default createStyles;
